import React, { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button, Result } from 'antd';

type Props = { children: ReactNode };
type State = { hasError: boolean; message: string };

/**
 * 라우트 트리 한 겹 — 예기치 않은 렌더 예외 시 흰 화면 대신 복구 경로 제공.
 */
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: '' };

  static getDerivedStateFromError(err: Error): State {
    return { hasError: true, message: err.message || '알 수 없는 오류' };
  }

  componentDidCatch(err: Error, info: ErrorInfo): void {
    if (typeof console !== 'undefined' && console.error) {
      console.error('[ErrorBoundary]', err, info.componentStack);
    }
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 48, maxWidth: 560, margin: '0 auto' }}>
          <Result
            status="error"
            title="화면을 불러오지 못했습니다"
            subTitle={this.state.message}
            extra={
              <Button type="primary" onClick={() => window.location.reload()}>
                새로고침
              </Button>
            }
          />
        </div>
      );
    }
    return this.props.children;
  }
}
